export const contactsData = {
    email: 'umeaemun@gmail.com',
    address: 'Karachi, Pakistan',
    sheetAPI: ''
}